<modal [closable]="!saving">
  <div header [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}" class="uppercase">{{(type == 'income' ? 'Thêm khoản thu' : 'Thêm khoản chi') | lang}}</div>

  <label>{{'Ngày' | lang}}</label>
  <input type="text" class="text-primary bold pointer input" [disabled]="saving" readonly="true" (click)="editDate()" value="{{payment.Stamp | date : 'dd-MM-yyyy'}}"/>

  <label>{{'Nhóm dịch vụ' | lang}}</label>
  <select [(ngModel)]="group" [disabled]="saving">
    <option [ngValue]="0">{{'chọn nhóm' | lang}}</option>
    <option *ngFor="let i of groups" [ngValue]="i.ID">{{i.Name}}</option>
  </select>
  <label>{{'Tên dịch vụ' | lang}}</label>
  <select [(ngModel)]="service" [disabled]="group == 0 || saving">
    <option [ngValue]="0">{{'chọn dịch vụ' | lang}}</option>
    <option *ngFor="let i of services" [ngValue]="i.ID">{{i.Name}}</option>
  </select>
  <label>{{(type == 'income' ? 'Số tiền thu' : 'Số tiền chi') | lang}} (VND)</label>
  <number-input class="bold" [disabled]="saving" [value]="amount" (change)="amount = $event.target.value" [allowNegativeValue]="false" [decimalPlaces]="0" [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}"></number-input>
  <label>{{'Lý do' | lang}}</label>
  <textarea [disabled]="saving" [(ngModel)]="payment.Notes"></textarea>
  <div class="flex space-between">
    <button class="bg-danger text-white std-margin-right" [disabled]="saving" *ngIf="payment.ID > 0 && !edited" (click)="cancel()"><i class="fa fa-times"></i><span>{{'Hủy phiếu' | lang}}</span></button>
    <button class="bg-primary text-white std-margin-right" [disabled]="saving" *ngIf="payment.ID > 0 && !edited" (click)="confirm()"><i class="fa fa-check"></i><span>{{'Xác nhận' | lang}}</span></button>
    <button class="bg-success text-white std-margin-right" [disabled]="!savable" *ngIf="payment.ID == 0 || edited" (click)="save()"><i class="fa fa-save"></i><span>{{(payment.ID < 1 ? 'Tạo phiếu' : 'Lưu thay đổi') | lang}}</span></button>
    <button class="bg-warning text-white" [disabled]="saving" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
